import { gql } from "@apollo/client";

export const CREATE_INVOICE_ITEM = gql`
  mutation create_invoice_item($input: invoice_items_insert_input!) {
    insert_invoice_items_one(object: $input) {
      id
    }
  }
`;

export const UPDATE_INVOICE_ITEM = gql`
  mutation update_invoice_item($id: Int!, $input: invoice_items_set_input!) {
    update_invoice_items_by_pk(pk_columns: { id: $id }, _set: $input) {
      id
    }
  }
`;

export const DELETE_INVOICE_ITEM = gql`
  mutation delete_invoice_item($id: Int!) {
    delete_invoice_items_by_pk(id: $id) {
      id
    }
  }
`;
